module.exports = __webpack_public_path__ + "static/media/googCircleIcon.5449b457.png";